import { render } from "./FilterGlobalInformations.vue?vue&type=template&id=545e0348&scoped=true"
import script from "./FilterGlobalInformations.vue?vue&type=script&lang=ts"
export * from "./FilterGlobalInformations.vue?vue&type=script&lang=ts"

import "./FilterGlobalInformations.vue?vue&type=style&index=0&id=545e0348&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-545e0348"

export default script